import { call, takeEvery } from 'redux-saga/effects';

import { OrderTrackingResponse } from 'order/wizard/orderTracking/interface/OrderTracking';
import { orderTrackingActions } from 'order/wizard/orderTracking/store/orderTrackingActions';

import { Action } from 'shared/interface/Action';
import ApiService from 'shared/services/api.service';
import UtilService from 'shared/services/util.service';

function* getOrderTrackingSaga(action: Action<string, OrderTrackingResponse>) {
  try {
    const response: OrderTrackingResponse = yield call(
      ApiService.get,
      `/api/order/orders/${action.payload}/tracking/FedEx`
    );

    if (action.onSuccess) {
      yield call(action.onSuccess, response);
    }
  } catch (e) {
    UtilService.catchErrorHandler(e, action.onFailed);
  }
}

export function* orderTrackingSagas() {
  yield takeEvery(
    orderTrackingActions.GET_ORDER_TRACKING,
    getOrderTrackingSaga
  );
}
